export default [
  { value: "açaí" },
  { value: "apple" },
  { value: "akee" },
  { value: "apricot" },
  { value: "avocado" },
  { value: "banana" },
  { value: "bilberry" },
  { value: "blackberry" },
  { value: "blackcurrant" },
  { value: "black sapote" },
  { value: "blueberry" },
  { value: "boysenberry" },
  { value: "buddha's hand (fingered citron)" },
  { value: "crab apples" },
  { value: "currant" },
  { value: "cherry" },
  { value: "cherimoya (custard apple)" },
  { value: "chico fruit" },
  { value: "cloudberry" },
  { value: "coconut" },
  { value: "cranberry" },
  { value: "cucumber" },
  { value: "damson" },
  { value: "date" },
  { value: "dragonfruit (or pitaya)" },
  { value: "durian" },
  { value: "elderberry" },
  { value: "feijoa" },
  { value: "fig" },
  { value: "goji berry" },
  { value: "gooseberry" },
  { value: "grape" },
  { value: "raisin" },
  { value: "grapefruit" },
  { value: "guava" },
  { value: "honeyberry" },
  { value: "huckleberry" },
  { value: "jabuticaba" },
  { value: "jackfruit" },
  { value: "jambul" },
  { value: "japanese plum" },
  { value: "jostaberry" },
  { value: "jujube" },
  { value: "juniper berry" },
  { value: "kiwano (horned melon)" },
  { value: "kiwifruit" },
  { value: "kumquat" },
  { value: "lemon" },
  { value: "lime" },
  { value: "loquat" },
  { value: "longan" },
  { value: "lychee" },
  { value: "mango" },
  { value: "mangosteen" },
  { value: "marionberry" },
  { value: "melon" },
  { value: "cantaloupe" },
  { value: "honeydew" },
  { value: "watermelon" },
  { value: "miracle fruit" },
  { value: "mulberry" },
  { value: "nectarine" },
  { value: "nance" },
  { value: "olive" },
  { value: "orange" },
  { value: "blood orange" },
  { value: "clementine" },
  { value: "mandarine" },
  { value: "tangerine" },
  { value: "papaya" },
  { value: "passionfruit" },
  { value: "peach" },
  { value: "pear" },
  { value: "persimmon" },
  { value: "plantain" },
  { value: "plum" },
  { value: "prune (dried plum)" },
  { value: "pineapple" },
  { value: "pineberry" },
  { value: "plumcot (or pluot)" },
  { value: "pomegranate" },
  { value: "pomelo" },
  { value: "purple mangosteen" },
  { value: "quince" },
  { value: "raspberry" },
  { value: "salmonberry" },
  { value: "rambutan (or mamin chino)" },
  { value: "redcurrant" },
  { value: "salal berry" },
  { value: "salak" },
  { value: "satsuma" },
  { value: "soursop" },
  { value: "star apple" },
  { value: "star fruit" },
  { value: "strawberry" },
  { value: "surinam cherry" },
  { value: "tamarillo" },
  { value: "tamarind" },
  { value: "ugli fruit" },
  { value: "yuzu" },
  { value: "white currant" },
  { value: "white sapote" }
];



// WEBPACK FOOTER //
// ./src/components/fruits.js